import React from 'react';
const BusyIndicatorContext = React.createContext(null);
export default BusyIndicatorContext;
